module.exports = __webpack_public_path__ + "img/function_img2_fan.f72da8b8.png";